/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PutApiV1SerieIdMutationRequest,
  PutApiV1SerieIdMutationResponse,
  PutApiV1SerieIdPathParams,
  PutApiV1SerieId400,
  PutApiV1SerieId401,
  PutApiV1SerieId404,
  PutApiV1SerieId500,
} from "../../types/serieRegistroController/PutApiV1SerieId.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { putApiV1SerieId } from "../../clients/serieRegistroController/putApiV1SerieId.ts";

export const putApiV1SerieIdMutationKey = () =>
  [{ url: "/api/v1/serie/:id" }] as const;

export type PutApiV1SerieIdMutationKey = ReturnType<
  typeof putApiV1SerieIdMutationKey
>;

export function putApiV1SerieIdMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<PutApiV1SerieIdMutationRequest>> & {
    client?: Client;
  } = {},
) {
  const mutationKey = putApiV1SerieIdMutationKey();
  return mutationOptions<
    PutApiV1SerieIdMutationResponse,
    ResponseErrorConfig<
      | PutApiV1SerieId400
      | PutApiV1SerieId401
      | PutApiV1SerieId404
      | PutApiV1SerieId500
    >,
    {
      id: PutApiV1SerieIdPathParams["id"];
      data?: PutApiV1SerieIdMutationRequest;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ id, data }) => {
      return putApiV1SerieId(id, data, config);
    },
  });
}

/**
 * @description Atualiza uma série (multipart/form-data). Atualiza título/resumo no idioma corrente, sincroniza as turmas e permite substituir ou remover a imagem de capa. **(Requer Authorization para autenticação)**
 * @summary Atualizar série (Requer Authorization para autenticação)
 * {@link /api/v1/serie/:id}
 */
export function usePutApiV1SerieId<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PutApiV1SerieIdMutationResponse,
      ResponseErrorConfig<
        | PutApiV1SerieId400
        | PutApiV1SerieId401
        | PutApiV1SerieId404
        | PutApiV1SerieId500
      >,
      {
        id: PutApiV1SerieIdPathParams["id"];
        data?: PutApiV1SerieIdMutationRequest;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<PutApiV1SerieIdMutationRequest>> & {
      client?: Client;
    };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? putApiV1SerieIdMutationKey();

  const baseOptions = putApiV1SerieIdMutationOptions(
    config,
  ) as UseMutationOptions<
    PutApiV1SerieIdMutationResponse,
    ResponseErrorConfig<
      | PutApiV1SerieId400
      | PutApiV1SerieId401
      | PutApiV1SerieId404
      | PutApiV1SerieId500
    >,
    {
      id: PutApiV1SerieIdPathParams["id"];
      data?: PutApiV1SerieIdMutationRequest;
    },
    TContext
  >;

  return useMutation<
    PutApiV1SerieIdMutationResponse,
    ResponseErrorConfig<
      | PutApiV1SerieId400
      | PutApiV1SerieId401
      | PutApiV1SerieId404
      | PutApiV1SerieId500
    >,
    {
      id: PutApiV1SerieIdPathParams["id"];
      data?: PutApiV1SerieIdMutationRequest;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PutApiV1SerieIdMutationResponse,
    ResponseErrorConfig<
      | PutApiV1SerieId400
      | PutApiV1SerieId401
      | PutApiV1SerieId404
      | PutApiV1SerieId500
    >,
    {
      id: PutApiV1SerieIdPathParams["id"];
      data?: PutApiV1SerieIdMutationRequest;
    },
    TContext
  >;
}
